import React, { useCallback, useMemo, useRef, useState } from 'react';
import { buildLandingHtml } from './landingHtml';
import ScoringModal from './ScoringModal';
import { useNewLandingEffects } from './useNewLandingEffects';
import './newLanding.css';

const NewLanding: React.FC = () => {
  const rootRef = useRef<HTMLDivElement>(null);
  const [scoringOpen, setScoringOpen] = useState(false);
  const html = useMemo(() => buildLandingHtml(), []);
  const openScoring = useCallback(() => setScoringOpen(true), []);
  const closeScoring = useCallback(() => setScoringOpen(false), []);

  useNewLandingEffects(rootRef, openScoring);

  return (
    <div className="newLanding" ref={rootRef}>
      <div dangerouslySetInnerHTML={{ __html: html }} />
      <ScoringModal open={scoringOpen} onClose={closeScoring} />
    </div>
  );
};

export default NewLanding;
